export const BAR_PADDING = 0.1;
export enum BarChartXAxisType {
  DATE = 'date',
  STRING = 'string',
}
export const BAR_CHART_ANIMATION_DURATION = 500;
